import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/hooks/useToast";

type UseCopyLinkToastOptions = {
  showSuccessToast?: boolean;
};

export function useCopyLinkToast({
  showSuccessToast = true,
}: UseCopyLinkToastOptions = {}) {
  const { t } = useTranslation();
  const { toast } = useToast();

  return useCallback(
    async (action: () => Promise<void>) => {
      try {
        await action();
        if (showSuccessToast) {
          toast({
            title: t("common.success"),
            description: t("common.linkCopied"),
          });
        }
        return true;
      } catch (error) {
        console.error("Failed to copy link:", error);
        toast({
          title: t("common.error"),
          description: t("common.linkCopyFailed"),
          variant: "error",
        });
        return false;
      }
    },
    [showSuccessToast, t, toast],
  );
}
